import { UserAgent } from '#src/containers/UserAgent'

export default function isSupportedBrowser(userAgent?: UserAgent) {
  const unsupportedBrowsers: Array<string> = ['IE']
  return unsupportedBrowsers.includes((userAgent && userAgent.browser.name) || '') ? false : true
}
